import { Column, Entity, PrimaryColumn } from "typeorm";

import { Title } from "../../_objects/title";
import { TenantIdSchemaBase } from "../interfaces/tenantId.base";

/**
 * TitleSchema インターフェイス。
 */
export interface ITitleSchema {
  tenantId: string;
  id: string;
  items: string;
  isDeleted: boolean;
  isValid: boolean;
  createDate: string;
  createdBy: string;
  lastUpdateDate: string;
  lastUpdatedBy: string;
  schemaVersion: string;
}

@Entity()
export class TitleSchema implements TenantIdSchemaBase, ITitleSchema {
  @PrimaryColumn()
  tenantId: string;

  @Column({ nullable: true })
  id: string | null;

  @Column({ nullable: true })
  items: string | null;

  @Column({ nullable: true })
  isDeleted: boolean | null;

  @Column({ nullable: true })
  isValid: boolean | null;

  @Column({ nullable: true })
  createDate: string | null;

  @Column({ nullable: true })
  createdBy: string | null;

  @Column({ nullable: true })
  lastUpdateDate: string | null;

  @Column({ nullable: true })
  lastUpdatedBy: string | null;

  @Column({ nullable: true })
  schemaVersion: string | null;

  constructor(tenantId: string, title?: Title) {
    if (title) {
      this.tenantId = tenantId;
      this.id = title.id;
      this.items = title.items ? JSON.stringify(title.items) : null;
      this.isDeleted = title.isDeleted;
      this.isValid = title.isValid;
      this.createDate = title.createDate;
      this.createdBy = title.createdBy;
      this.lastUpdateDate = title.lastUpdateDate;
      this.lastUpdatedBy = title.lastUpdatedBy;
      this.schemaVersion = title.schemaVersion;
    }
  }
}
